import { Action } from '../types/action';

// eslint-disable-next-line @typescript-eslint/no-empty-function, no-empty-function
export const doNothing = (): Action => () => {};
